export const customEventBus = document.createElement("div");
